/**
 * Lançamentos "por evento" (contrato condicional) ficam Pendentes no banco, mas só devem
 * influenciar fluxo de caixa, KPIs e totais mensais após agendamento explícito:
 * - data de recebimento (payment_date), ou
 * - marca de previsão em payment_notes (definida no formulário ao escolher "Data prevista").
 */
export const POR_EVENTO_CONDITIONAL_TYPE = "por_evento";

export const FINANCEIRO_PREVISAO_MARKER = "[financeiro:previsao]";

export function stripFinanceiroPrevisaoMarker(text: string): string {
  return String(text || "")
    .split(FINANCEIRO_PREVISAO_MARKER)
    .join("")
    .replace(/\s{2,}/g, " ")
    .trim();
}

export function entryCountsInOperationalFinance(entry: {
  is_conditional_payment?: boolean | null;
  conditional_type?: string | null;
  payment_date?: string | null;
  payment_notes?: string | null;
}): boolean {
  if (
    !entry.is_conditional_payment ||
    entry.conditional_type !== POR_EVENTO_CONDITIONAL_TYPE
  ) {
    return true;
  }
  if (entry.payment_date) return true;
  const notes = String(entry.payment_notes || "");
  return notes.includes(FINANCEIRO_PREVISAO_MARKER);
}
